import React from "react";

import { Box, Container, Grid, Typography } from "@mui/material";

export default function AccessDenied(props) {
  const { message } = props;
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid
          container
          sx={{
            gap: 2,
            p: 2,
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h3" gutterBottom>
              {message || "401 - Access Denied"}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
